import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateEntry } from 'apps/builder/store/actions/entries';
import { whiteLabelSelector } from 'apps/builder/store/selectors';
import { FancyToggle } from 'apps/builder/components/settings/modal';
import { WhiteLabelCheck } from 'apps/builder/components/shared';
import { hipaaCompliantSelector } from 'apps/builder/store/selectors';

const UnsecuredAccessToggle = ({ guid, allow_unsecured_access, mediaType }) => {
  const isWhiteLabeled = useSelector(whiteLabelSelector)
  const dispatch = useDispatch()
  const hipaaCompliant = useSelector(hipaaCompliantSelector)
  const showUnsecuredAccessToggle = !hipaaCompliant
  
  return (
    <div className="toggles-group">
      <div className="toggle-wrapper">
        {showUnsecuredAccessToggle && (
          <FancyToggle
              label="Unsecured Access"
              id={guid}
              active={allow_unsecured_access}
              inlineBorderTooltipStyle={true}
              onChange={checked => {
                dispatch(
                  updateEntry({
                    guid,
                    allow_unsecured_access: checked,
                  })
                )
              }}
              className={'photo-more-settings'}
              tooltip={
                <>
                  {`Checking this box will make ${mediaType} uploaded to this field accessible via URL even if you are not logged in${isWhiteLabeled ? '' : ' to GoCanvas'}. `}
                  <WhiteLabelCheck>
                    <div>
                      <a
                        href="https://help.gocanvas.com/hc/en-us/articles/23404128090391-What-is-the-Unsecured-Access-setting-in-the-Builder"
                        target="blank"
                      >
                        Learn More
                      </a>
                    </div>
                  </WhiteLabelCheck>
                </>
              }
              tooltipDirection="bottom"
            />
          )}
      </div>
    </div>
  )
}

export default UnsecuredAccessToggle;